
//import '../../scss/master.scss';

import JQuery, { each } from 'jquery';
import '../../lib/jquery.extendable.js';
import '../../lib/jquery.nivasSelect.js';

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Swiper, { Navigation, Pagination, Scrollbar } from "swiper";
import MicroModal from 'micromodal';
import Headroom from "headroom.js";

import './gtm.js';

window.$ = window.JQuery = JQuery;

window.axios = require('axios');

//axios.defaults.headers.post['Content-Type'] = 'application/json';


/**
	* Summary:
    *
	* 0. Helpers
 	* 1. Navigation
	* 2. Vue JS
 	* 3. Functionality
	* 4. Sliders
	* 5. Vudu JS
	* 6. Phobs JS
	* 7. Func Call
*/


/* 0. Helpers */
function isDataLayerReady() {
	return typeof window.dataLayer !== 'undefined' &&
		Array.isArray(window.dataLayer) && // GTM initializes dataLayer as an array
		typeof window.dataLayer.push === 'function'; // Crucially, it must have the push method
}

// https://davidwalsh.name/javascript-debounce-function
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

var fwajax =
{
	type: 'POST',
	dataType: 'json',
	langSegment: '/',
	verbose: true,

	callback_globalAjaxError: function( XMLHttpRequest, textStatus, errorThrown)
	{
		if(fwajax.verbose)
			alert('ajax error: ' + textStatus );
	}

	,

	phpExecute : function(controlObject)
	{


		var obj=new Object;

		obj[ '_fwajax_url' ] = controlObject.url;
		obj[ '_fwajax' ] = '_fwajax';

		for(var i=1; i<arguments.length; i++)
		{
			var objIx='_fwajax_a' + (i-1);
			obj[ objIx ]=arguments[i];
		}

		var newUrl=fwajax.langSegment;
		if( controlObject.url.length >= 1 && controlObject.url.charAt(0)=='/')
			newUrl += controlObject.url.substr(1);
		else
			newUrl += controlObject.url;

		$.ajax(
			{
				url: newUrl,
				data: obj,
				success: fwajax.jsExecute,
				//error: callback_error_test2,
				timeout: 8000
			}
		);
	} // phpExecute

	,


	jsExecute : function(controlObject, statusText)
	{
		if( typeof( controlObject['_fwajax'] ) == 'undefined' || controlObject['_fwajax']!='_fwajax')
		{
			if(fwajax.verbose)
			{
				alert('jsExecute: Invalid JSON');
			}

			return;
		}

		if( typeof( controlObject['_fwajax_callback'] ) == 'undefined' || controlObject['_fwajax_callback']=='')
		{
			return;
		}

		var callback=controlObject['_fwajax_callback'];

		var evalArgs='';

		for(var i=0; ; i++)
		{
			var ix='_fwajax_a'+i;

			var argType= typeof( controlObject[ix] );

			if( argType == 'undefined')
				break;

			if(evalArgs != '')
				evalArgs += ', ';

			if( argType == 'string')
			{
				//evalArgs += '"' + controlObject[ix].replace(/"/g, '\\"') + '"';
				evalArgs += '"' + controlObject[ix] + '"';
			}
			else
			{
				evalArgs +=  controlObject[ix] ;
			}
		}

		var evalCode=callback+'(' + evalArgs + ')';

		eval( evalCode );

	} // jsExecute
};

$.ajaxSetup(
	{
		type: "POST",
		dataType: "json",
		error: fwajax.callback_globalAjaxError
	}
);

var isMobile = {
	Android: function() {
		return navigator.userAgent.match(/Android/i);
	},
	BlackBerry: function() {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	iOS: function() {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	iPad: function() {
		return navigator.userAgent.match(/iPad/i);
	},
	Opera: function() {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows: function() {
		return navigator.userAgent.match(/IEMobile/i);
	},
	any: function() {
		return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.iPad() || isMobile.Opera() || isMobile.Windows());
	}
};


/* 1. Navigation */

function headerNav() {
	var tl = gsap.timeline({
		// paused: true,
		reversed: false,
		/*onReverseComplete: function() {
			gsap.set("#navigation", { display: "none" });
		}*/
	})


	var linksTl = gsap.timeline({
		// paused: true,
		reversed: false,
		/*onReverseComplete: function() {
			gsap.set("#navigation", { display: "none" });
		}*/
	})


	var navCloseTl = gsap.timeline({
		// paused: true,
		reversed: false,
		/*onReverseComplete: function() {
			gsap.set("#navigation", { display: "none" });
		}*/
	})

	$(".js-site-header-open").click(function (e) {
		e.preventDefault();

		$(".site-header__dropdown").addClass("is-active");
		$(this).prop("disabled", true);
		// $(".js-site-header-close").prop("disabled", false);
		$("body").addClass("noscroll");

		/*if ($(this).hasClass("is-active")) {
			$(this).removeClass("is-active");
			$(".site-header").removeClass("is-active");
		} else {
			$(this).addClass("is-active");
			$(".site-header").addClass("is-active");
		}*/

		// animateNav();
		// tl.reversed() ? tl.play() : tl.reverse();

		// desktop
		if (window.matchMedia('(min-width: 992px)').matches) {
			// console.log("desktop anim");

			if (tl.reversed()) {
				tl.play()
			} else {
				tl.to(".close-menu-box__bg", { duration: 0.5, y: '0' })
				.to(".main-menu-box__bg", { duration: 0.5, y: '0'}, "-=0.333" )
				.to(".contact-info-box__bg", { duration: 0.5, y: '0'}, "-=0.167" )
				.to(".social-menu-box", { duration: 0.5, y: '0'}, "-=0.25" )
			}

			if (linksTl.reversed()) {
				linksTl.play()
			} else {
				linksTl.to(".button-close-menu", { duration: 0.35, opacity: 1, delay: 0.117, })
				.to(".main-menu__item", {
					delay: 0.216,
					duration: 0.35,
					stagger: 0.083,
					opacity: 1,
					y: '0'
				})
				.to(".contact-info-box__item", { duration: 0.35, opacity: 1}, "-=0.183" )
				.to(".site-header__mask", { duration: 0.1, opacity: 1})
				.call(function() {
					$(".js-site-header-close").prop("disabled", false);
				})

			}

		}

		// mobile
		else {
			// console.log("mobile anim");

			if (tl.reversed()) {
				tl.play()
			} else {
				/*tl.to(".close-menu-box__bg", { duration: 0.5, y: '0' })
				.to(".main-menu-box__bg", { duration: 0.5, y: '0'}, "-=0.333" )
				.to(".contact-info-box__bg", { duration: 0.5, y: '0'}, "-=0.167" )
				.to(".social-menu-box", { duration: 0.5, y: '0'}, "-=0.25" )*/

				tl.to(".site-header__dropdown-bg", { duration: 0.5, y: '0' })
				.to(".social-menu-box", { duration: 0.35, opacity: 0}, "-=0.5" )
			}

			if (linksTl.reversed()) {
				linksTl.play()
			} else {
				linksTl.to(".button-close-menu", { duration: 0.35, opacity: 1, delay: 0.317, })
				.to(".main-menu__item", {
					delay: 0,
					duration: 0.4,
					stagger: 0.083,
					opacity: 1,
					y: '0',
					x: '0'
				})
				.to(".contact-info-box__item", { duration: 0.35, opacity: 1}, "-=0.7" )
				.to(".social-menu-box", { duration: 0.35, opacity: 1}, "-=0.6" )
				.to(".site-header__mask", { duration: 0.1, opacity: 1})
				.call(function() {
					$(".js-site-header-close").prop("disabled", false);
				})

			}

		}



	});


	$(".js-site-header-close").click(function (e) {
		e.preventDefault();

		// $(".site-header__dropdown").removeClass("is-active");
		$(this).prop("disabled", true);
		// $(".js-site-header-open").prop("disabled", false);
		$("body").removeClass("noscroll");

		/*if ($(this).hasClass("is-active")) {
			$(this).removeClass("is-active");
			$(".site-header").removeClass("is-active");
		} else {
			$(this).addClass("is-active");
			$(".site-header").addClass("is-active");
		}*/

		// tl.reverse();
		// linksTl.reverse();

		// animateNav();
		// tl.reversed() ? tl.play() : tl.reverse();

		if (window.matchMedia('(min-width: 992px)').matches) {

			navCloseTl.to(".site-header__dropdown", {
				// delay: 0.117,
				duration: 0.55,
				// stagger: 0.083,
				height: 0,
				// y: '0'
				onComplete: () => gsap.set([".close-menu-box__bg", ".main-menu-box__bg", ".button-close-menu", ".main-menu__item", ".contact-info-box__item", ".contact-info-box__bg", ".social-menu-box" ], {clearProps: true})
			})
			.call(function() {
				$(".site-header__dropdown").removeClass("is-active");
				// tl.restart();
				// tl.pause();
				// linksTl.restart();
				// linksTl.pause();
			})
			.to(".button-close-menu", { duration: 0.55, opacity: 0, delay: 0.117, }, "-=0.55" )
			.to(".main-menu__item", { duration: 0.55, opacity: 0, delay: 0.117, }, "-=0.55" )
			.to(".contact-info-box__item", { duration: 0.55, opacity: 0}, "-=0.55" )
			.to(".site-header__mask", { duration: 0.45, opacity: 0}, "-=0.5")
			.to(".site-header__dropdown", {
				height: "100%",
			})
			.call(function() {
				$(".js-site-header-open").prop("disabled", false);
			})

		}

		else {
			navCloseTl.to(".site-header__dropdown", {
				// delay: 0.117,
				duration: 0.55,
				// stagger: 0.083,
				height: 0,
				// y: '0'
				onComplete: () => gsap.set([".site-header__dropdown-bg", ".close-menu-box__bg", ".main-menu-box__bg", ".button-close-menu", ".main-menu__item", ".contact-info-box__item", ".contact-info-box__bg", ".social-menu-box" ], {clearProps: true})
			})
			.call(function() {
				$(".site-header__dropdown").removeClass("is-active");
				// tl.restart();
				// tl.pause();
				// linksTl.restart();
				// linksTl.pause();
			})
			.to(".button-close-menu", { duration: 0.55, opacity: 0, delay: 0.117, }, "-=0.55" )
			.to(".main-menu__item", { duration: 0.55, opacity: 0, delay: 0.117, }, "-=0.55" )
			.to(".contact-info-box__item", { duration: 0.55, opacity: 0}, "-=0.55" )
			.to(".site-header__mask", { duration: 0.45, opacity: 0}, "-=0.5")
			.to(".site-header__dropdown", {
				height: "100%",
			})
			.call(function() {
				$(".js-site-header-open").prop("disabled", false);
			})
		}



		// height:0,
	});



}

function headerNavOpen() {
	$(".js-site-header-open").click(function (e) {
		e.preventDefault();

		$(".site-header__dropdown").addClass("is-active");
		$(this).prop("disabled", true);
		$(".js-site-header-close").prop("disabled", false);

		/*if ($(this).hasClass("is-active")) {
			$(this).removeClass("is-active");
			$(".site-header").removeClass("is-active");
		} else {
			$(this).addClass("is-active");
			$(".site-header").addClass("is-active");
		}*/

		animateNav();
		// tl.reversed() ? tl.play() : tl.reverse();
	});

}

function headerNavClose() {
	$(".js-site-header-close").click(function (e) {
		e.preventDefault();

		$(".site-header__dropdown").removeClass("is-active");
		$(this).prop("disabled", true);
		$(".js-site-header-open").prop("disabled", false);

		/*if ($(this).hasClass("is-active")) {
			$(this).removeClass("is-active");
			$(".site-header").removeClass("is-active");
		} else {
			$(this).addClass("is-active");
			$(".site-header").addClass("is-active");
		}*/

		animateNav();
		// tl.reversed() ? tl.play() : tl.reverse();
	});

}

function mobileLangMenuToggle() {
	$(".js-mobile-lang-menu-toggle").click(function (e) {
		e.preventDefault();

		/*$(".mobile-lang-menu-nav").addClass("is-active");
		$(this).prop("disabled", true);
		$(".js-site-header-open").prop("disabled", false);*/

		if ($(this).hasClass("is-active")) {
			$(this).removeClass("is-active");
			$(".mobile-lang-menu-nav").removeClass("is-active");
		} else {
			$(this).addClass("is-active");
			$(".mobile-lang-menu-nav").addClass("is-active");
		}
	});

}

function animateNav() {
	console.log("animate nav");

	// const tl = gsap.timeline();
	var tl = gsap.timeline({
		// paused: true,
		// reversed: true,
		/*onReverseComplete: function() {
			gsap.set("#navigation", { display: "none" });
		}*/
	})


	tl.to(".close-menu-box__bg", { duration: 0.5, y: '0' })
	.to(".main-menu-box__bg", { duration: 0.5, y: '0'}, "-=0.333" )
	.to(".contact-info-box__bg", { duration: 0.5, y: '0'}, "-=0.167" )
	.to(".social-menu-box", { duration: 0.5, y: '0'}, "-=0.25" )
	// .to(".box", { duration: 1, backgroundColor: "#f38630" }, "+=0.5")
	// .to(".box", { duration: 1, x: 0, rotation: -360 }, "+=0.5")

	// tl.reversed() ? tl.play() : tl.reverse();

}


/* 3. Functionality */

var tabs = function() {

	var self = this;

	$( '.js-tabs .contact-tabs__link').click(function(e) {
		e.preventDefault();

		$( '.js-tabs .contact-tabs__item' ).removeClass('active');
		$(this.parentNode).addClass('active');


		let targetDataValue = $(this).data('target');


		$('.js-tabs .contact-tabs__content').find('.contact-tabs__inner').each(function () {
			var currentElement = $(this);

			if(currentElement.data('content') === targetDataValue || targetDataValue == 'all') {
				currentElement.addClass( "is-open")
				currentElement.slideDown(200);
			} else {
				currentElement.removeClass( "is-open");
				currentElement.slideUp(200);
			}
		});
	});
};

// mice ground plan: toggle table items
function gridTableItemsToggle() {
	$(".js-grid-table-items-toggle").click(function (e) {
		e.preventDefault();
		if ($(this).hasClass("is-active")) {
			$(this).removeClass("is-active");
			$(".grid-table__item").removeClass("is-active");
		} else {
			$(this).addClass("is-active");
			$(".grid-table__item").addClass("is-active");
		}
	});
}

// mice ground plan: highlight sections
function groundPlanHighlight() {
	$(".js-highlight-area").click(function (e) {
		e.preventDefault();
		e.stopPropagation();
		var classname = $(this).attr("data-id");
		var self = this;

		// console.log(classname, "classname");

		$(".highlight-areas__item").removeClass("is-active");

		if (classname == "area-6-5-4-3") {
			$(".highlight-areas__item[data-id='area-6']").addClass("is-active");
			$(".highlight-areas__item[data-id='area-5']").addClass("is-active");
			$(".highlight-areas__item[data-id='area-4']").addClass("is-active");
			$(".highlight-areas__item[data-id='area-3']").addClass("is-active");
		}
		else if (classname == "area-5-4-3") {
			$(".highlight-areas__item[data-id='area-5']").addClass("is-active");
			$(".highlight-areas__item[data-id='area-4']").addClass("is-active");
			$(".highlight-areas__item[data-id='area-3']").addClass("is-active");
		}
		else if (classname == "area-4-3") {
			$(".highlight-areas__item[data-id='area-4']").addClass("is-active");
			$(".highlight-areas__item[data-id='area-3']").addClass("is-active");
		}
		else if (classname == "area-2-1") {
			$(".highlight-areas__item[data-id='area-2']").addClass("is-active");
			$(".highlight-areas__item[data-id='area-1']").addClass("is-active");
		}
		else if (classname == "area-7-8") {
			$(".highlight-areas__item[data-id='area-7']").addClass("is-active");
			$(".highlight-areas__item[data-id='area-8']").addClass("is-active");
		}
		else {
			$(".highlight-areas__item[data-id=" + classname + "]").addClass("is-active");
		}

	});

	$(document).on('click', 'body', function(e) {
		$(".highlight-areas__item").removeClass("is-active");
	})

}

document.addEventListener("DOMContentLoaded", function() {

	// mice ground plan modals
	if ( $('.gp-modal').length) {

		MicroModal.init({
			openClass: 'is-open',
			awaitCloseAnimation: true,
			onShow: function(modal) {
				// console.log("micromodal open");
			},
			onClose: function(modal) {
				// console.log("micromodal close");
			},
			disableScroll: true, // [6]
			disableFocus: false, // [7]
		});

	}

	if ( $('.hero-home .hero__title').length) {
		$('.hero-home .hero__title').addClass('is-active');
	}

});


var animationText = {

	init: function() {
		var self = this;

		if ( $('.animation').length === 0 ) {
			return;
		}

		this.create();
	},
	create: function() {

		$('.animation').each(function(item, index){
			var self = this;
			var children = $(self).children();

			children.each(function(item, index){
				var self = this;

				var theString = this;
				var theStringText = this.textContent;
				var wordArray = [];
				var wordArray = theStringText.split(' ');

				theString.innerHTML= "";
				wordArray.forEach(function(item, index) {

					let string= "";

					for (var i = 0; i < item.length; i++) {

						if (i == 0 && item.length == 1 && item != " ") {
							let letter = ('<span class="animation-item"><span class="animation-letter">' + item.charAt(i) + '</span></span> ');
							string += letter;
						} else if(i == 0 && item != " " && item.length >= 1) {
							let letter = ('<span class="animation-item"><span class="animation-letter">' + item.charAt(i) + '</span>');
							string += letter;
						} else if(i == 0 && i == (item.length - 1)) {
							let letter = ('<span class="animation-letter">' + item.charAt(i) + '</span></span> ');
							string += letter;
						} else if (i == (item.length - 1)) {
							let letter = ('<span class="animation-letter">' + item.charAt(i) + '</span></span> ');
							string += letter;
						}else {
							let letter = ('<span class="animation-letter">' + item.charAt(i) + '</span>');
							string += letter;
						}
					}

					theString.innerHTML += string;
				});
			});
		})
	},
}

var animationTimeout = function(delay, item){
	setTimeout(function(){
		item.addClass("animate");
	}, delay);
}

var animationDelay = function() {

	var self = this;

	if($('.animation').hasClass("reveal") ){

		$('.animation').each(function(item, index){
			var self = this;
			var delay = 0;

			$(this).removeClass("anim-hide");

			let animationWrap = $(self).children();
			let animationItem = animationWrap.children();

			for (var i = 0; i < animationItem.length; i++) {
				let item = animationItem.eq(i);
				let allChildrenItem = item.children();

				if(i < 1) {
					animationTimeout(0.1, item);
					delay += allChildrenItem.length * 80;

				} else  {
					animationTimeout(delay, item);
					delay += allChildrenItem.length * 80;
				}
			}
			delay = 0;
		});
	}
};

// animation trigger for animationText
gsap.registerPlugin(ScrollTrigger);

//on viewport
const animatedHeadings = gsap.utils.toArray('.animation.animation-v');
animatedHeadings.forEach((heading) => {
	const anima = gsap.from(heading, {
		scrollTrigger: {
			toggleActions: "play none none reset",
			trigger: heading,
			start: "30% bottom",
			end: "+=900",
			//markers: true,
		//	start: "center 70%",
			onEnter: function(){
				heading.classList.add('reveal');
				animationDelay();
			},
		},
	});
});

//on load
$('.animation.animation-l').each(function(index, item){
	//item.classList.add('reveal');

	setTimeout(function(){
		item.classList.add('reveal');
	}, 100);
	setTimeout(function(){
		animationDelay();
	}, 150);

});


var heroScrollDownIndicator = function() {
	if ( $(".x-scrol-indicator").length > 0 ) {
		$(".x-scrol-indicator").on('click', function(event){
			event.preventDefault();
			$('body, html').animate({ scrollTop: $(".hero").outerHeight() }, 800);
		});
	}
};


/* 4. Sliders */

var pageSwiper = {

	element: '.js-swiper--expo',
	firstLoad: true,
	swiperTabs: undefined,
	map: [],
	tabs: [],

	init: function() {
		var self = this;

		if(self.swiperTabs == undefined){
			this.initSelector();
		}
	},

	destroy: function() {
		var self = this;

		if(self.swiperTabs !== undefined){
			self.swiperTabs.destroy(true, true);
		}
	},

	initSelector: function() {
		var self = this;

		self.swiperTabs = new Swiper('.js-swiper--expo', {
			modules: [Navigation, Pagination, Scrollbar],
			loop: false,
			slidesPerView: 1,
			spaceBetween: 67,

			navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
			breakpoints: {
				200: {
					slidesPerView: 1,
					spaceBetween: 48,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 67,
				},
			},

			init: function(swiper) {

				this.slideTo(getSlideIndexByClass('current'));
			},
		});
	},
};

/* 5. Vudu JS */

// gdpr
var VuduGdprPlugin = {


	options: {
		'necessary': {
			cookieName: 'gdpr_level_1_necessary',
			pristine: true,
			disabled: true,
			checked: true,
			el: 'gdpr_settings_choice_necessary'
		},
		'analytical': {
			cookieName: 'gdpr_level_2_analytical',
			pristine: true,
			disabled: false,
			checked: false,
			el: 'gdpr_settings_choice_analytical'
		},
		'marketing': {
			cookieName: 'gdpr_level_3_marketing',
			pristine: true,
			disabled: false,
			checked: false,
			el: 'gdpr_settings_choice_marketing'
		}
	},

	init: function () {


		if ($('#gdpr_toolbar').length) {
			this.bindEvent();

			var pristine = true;
			for (var i in VuduGdprPlugin.options) {
				var usersSelection = VuduGdprPlugin.options[i];

				var cookieValue = VuduGdprPlugin.getCookie(usersSelection.cookieName);
				if (cookieValue == 1) {
					pristine = false;

					if (usersSelection.disabled === false) {
						VuduGdprPlugin.options[i].checked = true;

						$("#" + usersSelection.el).prop("checked", true);
					}
				}
				else if (cookieValue == 0) {
					pristine = false;

					if (usersSelection.disabled === false) {
						VuduGdprPlugin.options[i].checked = false;

						$("#" + usersSelection.el).prop("checked", false);
					}
				}

			}

			if (pristine == false) {
				$("#js-toogle-gdpr").addClass("show");
				VuduGdprPlugin.hideToolbar();
			}
            else
			{
				$("#gdpr_toolbar").removeClass("hide");
			}
		}


	},

	bindEvent: function () {

		$('#gdpr_toolbar .x_submit_necessary').on("click", function (e) {
			e.preventDefault();

			VuduGdprPlugin.consentCookie('necessary', true);
			$('#gdpr_settings_choice_necessary').prop("checked", true);
			VuduGdprPlugin.consentCookie('analytical', false);
			$('#gdpr_settings_choice_analytical').prop("checked", false);
			VuduGdprPlugin.consentCookie('marketing', false);
			$('#gdpr_settings_choice_marketing').prop("checked", false);

			$('#gdpr-overlay').hide();
			$("#gdpr_settings_popup").removeClass("show");
			$('.gdpr-msg').removeClass("show");
			$('#gdpr_toolbar').addClass("hide");
			$('#js-toogle-gdpr').addClass("show");
		});


		$('#gdpr_toolbar .x_submit_all').on("click", function (e) {
			e.preventDefault();

			VuduGdprPlugin.consentCookie('necessary', true);
			$('#gdpr_settings_choice_necessary').prop("checked", true);
			VuduGdprPlugin.consentCookie('analytical', true);
			$('#gdpr_settings_choice_analytical').prop("checked", true);
			VuduGdprPlugin.consentCookie('marketing', true);
			$('#gdpr_settings_choice_marketing').prop("checked", true);

			$('#gdpr-overlay').hide();
			$("#gdpr_settings_popup").removeClass("show");
			$('.gdpr-msg').removeClass("show");
			$('#gdpr_toolbar').addClass("hide");
			$('#js-toogle-gdpr').addClass("show");
		});

		$('#gdpr_toolbar a.x_open_setup').on("click", function (e) {
			e.preventDefault();

			$('#gdpr_toolbar .gdpr-prompt__ctrl').toggleClass('active');
			$(this).toggleClass('active');
			$('#gdpr_settings_popup').toggleClass('show');
			$('.gdpr-msg').toggleClass('show');
		});

		$('#js-toogle-gdpr').on("click", function (e) {
			e.preventDefault();

			$('#gdpr_toolbar .gdpr-prompt__ctrl').removeClass('active');
			VuduGdprPlugin.showToolbar();
		});

		$("#gdpr_toolbar .x_submit_selected").on("click", function (e) {
			e.preventDefault();

			$("#gdpr_toolbar input.gdpr_level").each(function (index, item) {
				var name = $(item).val();
				var checked = $(this).prop("checked");
				VuduGdprPlugin.consentCookie(name, checked);
			});

			$('#gdpr_toolbar .gdpr-prompt__ctrl').removeClass('active');
			$('#gdpr_toolbar a.x_open_setup').removeClass('active');

			$('#gdpr-overlay').hide();
			$("#gdpr_settings_popup").removeClass("show");
			$('.gdpr-msg').removeClass("show");
			$('#gdpr_toolbar').addClass("hide");
			$('#js-toogle-gdpr').addClass("show");
		});
	},

	showToolbar: function () {
		$("#gdpr-overlay").show();
		$("#gdpr_toolbar").removeClass('hide');
	},

	hideToolbar: function () {
		$("#gdpr-overlay").hide();
		$("#gdpr_toolbar").addClass('hide');
	},

	consentCookie: function (name, checked) {

		if (VuduGdprPlugin.options[name] !== undefined) {
			var value = checked ? 1 : 0;
			VuduGdprPlugin.setCookie(VuduGdprPlugin.options[name].cookieName, value, 365);
		}
	},

	consentAllCookie: function () {

		for (var i in VuduGdprPlugin.options) {
			var usersSelection = VuduGdprPlugin.options[i];
			VuduGdprPlugin.consentCookie(usersSelection.cookieName, true);
		}
	},

	setLevel: function (lvl) {

		if (typeof (cookieDomainName) != 'undefined' && cookieDomainName) {
			//$.cookie(VuduGdprPlugin.cookieName, lvl, { expires: 365, path: '/', domain: cookieDomainName });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, lvl, 365, cookieDomainName);
		}
		else {
			//$.cookie(VuduGdprPlugin.cookieName, lvl, { expires: 365, path: '/' });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, lvl, 365);
		}
	},

	setMaxLevel: function () {

		if (typeof (cookieDomainName) != 'undefined' && cookieDomainName) {
			//$.cookie(VuduGdprPlugin.cookieName, 4, { expires: 365, path: '/', domain: cookieDomainName });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, 4, 365, cookieDomainName);
		}
		else {
			//$.cookie(VuduGdprPlugin.cookieName, 4, { expires: 365, path: '/' });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, 4, 365);
		}
	},

	setCookie: function (cname, cvalue, exdays, domain) {
		var domain = (typeof (domain) != 'undefined' && domain) ? domain : '.';
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var cookieExpires = "expires=" + d.toUTCString();
		var cookieDomain = "domain=" + domain;
		//document.cookie = cname + "=" + cvalue + ";" + cookieExpires + ";" + cookieDomain + ";path=/";
		document.cookie = cname + "=" + cvalue + ";" + cookieExpires;
	},

	getCookie: function (cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return null;
	}

}

// newsletter
var ArenaturistNewsletter =
{
	selector : {
		'message': '.newsletter_message',
		'success_message': '.newsletter_message.success',
		'error_message1': '.nm_one.error',
		'error_message1_name': '.nm_one_name.error',
		'error_message1_lastname': '.nm_one_lastname.error',

		'error_message2': '.nm_two.error',
		'error_message3': '.nm_three.error',
		'wrapInputs': '.newsletterWrapInputs',
		'input': '#newsletter_signup input[name=email]',
		'input_name': '#newsletter_signup input[name=first_name]',
		'input_lastname': '#newsletter_signup input[name=last_name]',
		'privola': '#newsletter_signup input[name=privola]',
		'button': '#newsletter_signup [type=submit]'
	},

	init: function()
	{

		console.log("ArenaNewsletter init");

		$(document).on('submit', '#newsletter_signup', function(e) {
			e.preventDefault();
			ArenaturistNewsletter.subscribe($(this));
		});


		$(document).on('submit', '#newsletter_redirect', function(e) {
			e.preventDefault();
			location.href= $(this).attr("data-redirect") + '?email=' + $(this).find('input[name=email]').val();
		});
	},


	subscribe: function($form)
	{

		var $input = $(this.selector.input);
		var $input_name = $(this.selector.input_name);
		var $input_lastname = $(this.selector.input_lastname);
		var $privola = $(this.selector.privola);
		var $msg = $(this.selector.message);

		var $errMsg1 = $(this.selector.error_message1);
		var $errMsg1_name = $(this.selector.error_message1_name);
		var $errMsg1_lastname = $(this.selector.error_message1_lastname);
		var $errMsg2 = $(this.selector.error_message2);
		var $errMsg3 = $(this.selector.error_message3);
		var $wrpInps = $(this.selector.wrapInputs);

		$(this.selector.input).removeClass('error');
		$(this.selector.input_name).removeClass('error');
		$(this.selector.input_lastname).removeClass('error');
		$(this.selector.wrapInputs).removeClass('errorArr').removeClass('successArr');
		$msg.removeClass('show');

		var validationOK = true;


		if( $privola.prop('checked') == false )
		{
			console.log('usli u 1');
			$(this.selector.input).addClass('error');
			$(this.selector.input_name).addClass('error');
			$(this.selector.input_lastname).addClass('error');
			$(this.selector.wrapInputs).addClass('errorArr');
			$(this.selector.error_message3).addClass('show');

			setTimeout( function() {
				$errMsg3.removeClass('show');
				$wrpInps.removeClass('errorArr');
			}, 5000);

			validationOK = false;
		}
		else if(  $input_name.val() == "")
		{
			console.log('usli u name');
			$(this.selector.input_name).addClass('error');
			$(this.selector.wrapInputs).addClass('errorArr');
			$(this.selector.error_message1_name).addClass('show');
			//setTimeout( ()=> {
			setTimeout( function() {
				$errMsg1_name.removeClass('show');
				$wrpInps.removeClass('errorArr');
			}, 5000);

			validationOK = false;
		}
		else if(  $input_lastname.val() == "")
		{
			console.log('usli u lastname');
			$(this.selector.input_lastname).addClass('error');
			$(this.selector.wrapInputs).addClass('errorArr');
			$(this.selector.error_message1_lastname).addClass('show');
			//setTimeout( ()=> {
			setTimeout( function() {
				$errMsg1_lastname.removeClass('show');
				$wrpInps.removeClass('errorArr');
			}, 5000);

			validationOK = false;
		}
		else if(  $input.val() == "")
		{
			console.log('usli u email');
			$(this.selector.input).addClass('error');
			$(this.selector.wrapInputs).addClass('errorArr');
			$(this.selector.error_message1).addClass('show');
			//setTimeout( ()=> {
			setTimeout( function() {
				$errMsg1.removeClass('show');
				$wrpInps.removeClass('errorArr');
			}, 5000);

			validationOK = false;
		}


		if(validationOK)
		{
			var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
			if(re.test($input.val()))
			{
				$(this.selector.button).attr("disabled","disabled");
				fwajax.phpExecute(
					{ url: '/' + langCode + '/xnewsletter/subscribe' },
					$input.val(),
					$input_name.val(),
					$input_lastname.val()
				);

			}
			else
			{
				console.log('Validation u redu');
				$(this.selector.input).addClass('error');
				$(this.selector.wrapInputs).addClass('errorArr');
				$(this.selector.error_message2).addClass('show');
				//setTimeout( ()=> {
				setTimeout( function() {
					$errMsg2.removeClass('show');
					$errMsg3.removeClass('show');
					$wrpInps.removeClass('errorArr');
				}, 5000);
			}
		}

		return false;
	},

	callbackSubscribe: function(str)
	{
		var $input = $(this.selector.input);
		var $privola = $(this.selector.privola);
		var $msg = $(this.selector.message);

		var $sucMsg = $(this.selector.success_message);
		var $wrpInp = $(this.selector.wrapInputs);


		$(this.selector.button).removeAttr("disabled","disabled");

		if(str)
		{
			var res = jQuery.parseJSON(str);
			if(res.status>0)
			{
				$(this.selector.success_message).addClass('show');
				$(this.selector.wrapInputs).removeClass('errorArr').addClass('successArr');
				$(this.selector.input).removeClass('error');

				$privola.prop('checked', false);
				$('form#newsletter_signup').trigger("reset");
				$input.val("");

				//setTimeout( ()=> {
				setTimeout( function() {
					$sucMsg.removeClass('show');
					$wrpInp.removeClass('successArr');
				}, 5000);
				// ga tracking
				gtm_Tracking.trackEvent('Newsletter', 'submit', 'success', 1);
			}
			else
			{
				$(this.selector.input).addClass('error');
				$(this.selector.wrapInputs).addClass('errorArr');
				$(this.selector.error_message).addClass('show');
			}
		}

	}
};

// pswp
var VuduGallery = {

    pswpElement: false,

    init: function() {
        this.pswpElement = document.querySelectorAll('.pswp')[0];
    },

	bindEvenets: function() {
        this.bindGallery();
        this.bindVideo();
        this.bindLiveCam();
	},

    bindGallery: function() {
        var self = this;

        $(document).on("click touchtap", ".x_gallery", function(e){

        	console.error('NivasGallery touch');

            e.preventDefault();

            var imageContainer = $(this).attr("data-container");

            var imagez = [];
            $(imageContainer + " .item").each(function(item, index){

                var wh = $(this).attr("data-wh").split("x");

                var img = {};
                img.src = $(this).attr("href");
                img.w = wh[0];
                img.h = wh[1];
                img.title = $(this).attr("alt");
                img.author = $(this).attr("data-author");

                imagez.push(img);

            });


            var idx = $(imageContainer + " .item").index(this);

            var options = {
                index: idx,
                history: false,
                closeOnScroll: false,
                overtitle: $(this).attr("data-overtitle"),
                title: $(this).attr("data-title")
            };

            // ga tracking
            gtm_Tracking.trackEvent('Image Gallery', 'open', options.title, 1);

            self.openOverlay(imagez, options);
			//  console.log(imagez);
        });

        $(document).on("click touchtap", ".x_image", function(e){
            e.preventDefault();

            var $imageContainer = $(this).parents(".x_gallery_inline");

            var imagez = [];
            $imageContainer.find(".x_image").each(function(index, item){

                var wh = $(this).attr("data-wh").split("x");

                var img = {};
                img.src = $(this).attr("href");
                img.w = wh[0];
                img.h = wh[1];
                img.title = $(this).attr("alt");
                img.author = $(this).attr("data-author");
                img.index = index;

                imagez.push(img);

            });


            var idx = $imageContainer.find(".g").index(this);

            var options = {
                index: idx,
                history: false,
                closeOnScroll: false,
                overtitle: $imageContainer.attr("data-overtitle"),
                title: $imageContainer.attr("data-title")
            };

            // ga tracking
            gtm_Tracking.trackEvent('Image Gallery', 'open', options.title, 1);

            self.openOverlay(imagez, options);

        });

    },

    bindVideo: function() {

        var self = this;

        // Youtube videos only
        $(document).on("click touchtap", ".x_video", function(e){
            e.preventDefault();

            self.iframes = {};

            var imageContainer = $(this).attr("data-container");
            var pswpElement = document.querySelectorAll('.pswp')[0];

            var imagez = [];
            $(imageContainer + " .item").each(function(item, index){

                var img = {};
                img.html = $(this).html();
                img.title = $(this).attr("data-title");
                img.author = "";

                imagez.push(img);
            });


            var idx = $(imageContainer + " .item").index(this);

            var options = {
                index: idx,
                history: false,
                closeOnScroll: false,
                overtitle: $(this).attr("data-overtitle"),
                title: $(this).attr("data-title")
            };


            // ga tracking
            gtm_Tracking.trackEvent('Video Gallery', 'open', options.title, 1);

            var pswp = self.openOverlay(imagez, options);
            pswp.listen('afterChange', function() {

                $(".pswp .ytb").each(function(index, item){

                    if(index!=pswp.getCurrentIndex())
                    {
                        self.pauseVideo("ytb-" + index);
                    }
                    else
                    {
                        self.playVideo("ytb-" + index);
                    }

                });

            });

        });

	},

    bindLiveCam: function() {

        var self = this;

        // Youtube videos only
        $(document).on("click touchtap", ".x_live", function(e){
            e.preventDefault();

            self.iframes = {};

            var imageContainer = $(this).attr("data-container");
            var pswpElement = document.querySelectorAll('.pswp')[0];

            var imagez = [];
            $(imageContainer + " .item").each(function(item, index){

                var img = {};
                img.html = $(this).html();
                img.title = $(this).attr("data-title");
                img.author = "";

                imagez.push(img);
            });


            var idx = $(imageContainer + " .item").index(this);

            var options = {
                index: idx,
                history: false,
                closeOnScroll: false,
                overtitle: $(this).attr("data-overtitle"),
                title: $(this).attr("data-title")
            };


            // ga tracking
            gtm_Tracking.trackEvent('Live cam', 'open', options.title, 1);

            var pswp = self.openOverlay(imagez, options);
            // pswp.listen('afterChange', function() {

            //     $(".pswp .ytb").each(function(index, item){

            //         if(index!=pswp.getCurrentIndex())
            //         {
            //             self.pauseVideo("ytb-" + index);
            //         }
            //         else
            //         {
            //             self.playVideo("ytb-" + index);
            //         }

            //     });

            // });

        });

    },


    openOverlay: function(imagez, optionz, selector) {

		if(selector==undefined)
		{
			selector = '.pswp.inline';
		}

		this.pswpElement = document.querySelectorAll(selector)[0];

        var self = this;

        var userOptions = (optionz!==undefined && typeof object) ? optionz : {};

        var options = {

            overtitle: false,
            title: false,

            index: 0,
            modal: true,
            history: false,
            loop: true,

            // Buttons/elements
            closeEl: true,
            captionEl: true,
            fullscreenEl: false,
            zoomEl: false,
            shareEl: false,
            counterEl: false,
            arrowEl: true,
            preloaderEl: false,

            // close
            escKey: true,
            pinchToClose: false,
            tapToClose: true,
            closeOnVerticalDrag: false,
            verticalDragRange: 1,
            clickToCloseNonZoomable: false,
            closeOnScroll: false,

            showAnimationDuration: 500,
            hideAnimationDuration: 200
        };
        _.extend(options, userOptions);



        var gallery = new PhotoSwipe( self.pswpElement, PhotoSwipeUI_Default, imagez, options);
        gallery.init();
        gallery.listen('close', function() {
            $(".pswp__container .pswp__item").html("");
        });


        $(".pswp .pswp__head").hide();
        if(options.overtitle || options.title)
        {
            $(".pswp .pswp__head").show();
            $(".pswp .galleryName").html(options.overtitle);
            $(".pswp .galleryDesc").html(options.title);
        }



        return gallery;
    },

    iframes: {},

    pauseVideo: function(sel) {

        if(this.iframes[sel] === undefined)
        {
            var iframe = $(".pswp #" + sel)[0];
            this.iframes[sel] = iframe.contentWindow ? iframe.contentWindow : iframe.contentDocument.defaultView;
        }

        this.iframes[sel].postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    },

    playVideo: function(sel) {

        if(this.iframes[sel] === undefined)
        {
            var iframe = $(".pswp #" + sel)[0];
            this.iframes[sel] = iframe.contentWindow ? iframe.contentWindow : iframe.contentDocument.defaultView;
        }

        this.iframes[sel].postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }

};

/* 2. Vue JS */

// property single thumb strip
var pGalleryThumb = {

	element: '.xswiper--thumb',
	swiperTabs: undefined,

	init: function() {
		if(pGalleryThumb.swiperTabs === undefined && $(pGalleryThumb.element).length){
			pGalleryThumb.initSelector();
		}
	},

	destroy: function() {

		if(typeof pGalleryThumb.swiperTabs !== 'undefined'){
			pGalleryThumb.swiperTabs.destroy(true, true);
		}

		$(pGalleryThumb.element).hide();
	},

	initSelector: function() {

		$(pGalleryThumb.element).show();

		pGalleryThumb.swiperTabs = new Swiper(pGalleryThumb.element, {
			loop: true,
			spaceBetween: 1,
			slidesPerView: 4,
			freeMode: true,
			watchSlidesProgress: true,
		});

		console.log('PropertySingleThumb', pGalleryThumb.swiperTabs);

	},
};
window.pGalleryThumb = pGalleryThumb;

// property single main img slider
var pGallery = {

	element: '.xswiper--slide',
	swiperTabs: undefined,

	init: function() {
		pGallery.initSelector();
	},

	destroy: function() {

		if(typeof pGallery.swiperTabs != 'undefined'){
			if(!Array.isArray(pGallery.swiperTabs))
				pGallery.swiperTabs.destroy(true, true);
			else {
				for(let i = 0 ; i < pGallery.swiperTabs.length ; i++)
					pGallery.swiperTabs[i].destroy(true, true);
			}
		}
	},

	initSelector: function() {

		pGallery.swiperTabs = new Swiper(pGallery.element, {
			loop: true,
			spaceBetween: 1,
			slidesPerView: 1,

			modules: [Navigation, Pagination, Scrollbar],

			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},

			pagination: {
				el: ".swiper-pagination",
				type: "fraction",
			},

			thumbs: {
				swiper: pGalleryThumb.swiperTabs,
			},

			init: function(swiper) {
				//this.slideTo(getSlideIndexByClass('current'));
			},
		});

		console.log('PropertySingleMain', pGallery.swiperTabs);

	},
};
window.pGallery = pGallery;


// Vue gallery opened in modal
var VueGallery = {

	element: '.xswiper--gallery',
	swiperTabs: [],

	init: function() {

		if(VueGallery.swiperTabs.length === 0){
			VueGallery.initSelector();
		}
	},

	destroy: function() {

		if(VueGallery.swiperTabs !== undefined){
			VueGallery.swiperTabs.destroy(true, true);
		}
	},

	initSelector: function() {

		VueGallery.swiperTabs = new Swiper(VueGallery.element, {
			loop: false,
			spaceBetween: 0,
			slidesPerView: 1,
			modules: [Navigation, Pagination, Scrollbar],
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: ".swiper-pagination",
				type: "fraction",
			},

			init: function(swiper) {

				//this.slideTo(getSlideIndexByClass('current'));
			},

			on: {
				init: function () {
					let value = $('.xswiper--gallery .swiper-slide-active .swiper-slide-label').text();
					$('.xswiper--gallery .w-swiper__img-label').html(value);
				},
				slideChangeTransitionEnd: function () {
					let value = $('.xswiper--gallery .swiper-slide-active .swiper-slide-label').text();
					$('.xswiper--gallery .w-swiper__img-label').html(value);
				},
			},
		});

	},

	changeLabel: function() {
		let value = $('.xswiper--gallery .swiper-slide-active .swiper-slide-label').text();
		$('.xswiper--gallery .w-swiper__img-label').html(value);
	},

};

window.gallery = VueGallery;


/* 6.Phobs JS */

// phobs - Property amenities popup toggle
function amenitiesPopupToggle() {
	$(".js-close-amenities-popup").click(function (e) {
		e.preventDefault();
		$(this).parent(".sidebar-unit-amenities__popup").removeClass("is-active");

	});

	$(".js-toggle-amenities-popup").click(function (e) {
		e.preventDefault();

		if ($(this).closest(".sidebar-unit-amenities").find(".sidebar-unit-amenities__popup").hasClass("is-active")) {
			$(this).closest(".sidebar-unit-amenities").find(".sidebar-unit-amenities__popup").removeClass("is-active");
		} else {
			$(this).closest(".sidebar-unit-amenities").find(".sidebar-unit-amenities__popup").addClass("is-active");
		}

	});
}


function getCookie(name) {
    function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
    var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
    return match ? match[1] : null;
}



/* 7. Func Call */

$(document).ready(function() {
	console.log('footer ready!');

	VuduGdprPlugin.init();
	ArenaturistNewsletter.init();

	const header = document.querySelector(".site-header");
	const headroom = new Headroom(header);
	headroom.init();

	$(".js-site-header-close").prop("disabled", true);
	headerNav();
	// headerNavOpen();
	// headerNavClose();

	mobileLangMenuToggle();
	$('.nvsSel').nivasSelect();
	tabs();

	pageSwiper.init();
	VuduGallery.init();
	VueGallery.init();

	amenitiesPopupToggle();
	gridTableItemsToggle();
	groundPlanHighlight();

	animationText.init();
	animationDelay();
	heroScrollDownIndicator();



	// init gtm
	// gtm_Tracking.init();
	// console.log("gtm_Tracking", gtm_Tracking);
	// console.log("gtm_Tracking.init();", gtm_Tracking.init());
	// console.log("window.gtm_Tracking.init();", window.gtm_Tracking.init());
	console.log("---------- all --------------------")
	// console.log("window.dataLayer:", window.dataLayer);
	// console.log("dataLayer (direct reference):", dataLayer); // Should be the same as window.dataLayer
	const dataLayerReady = isDataLayerReady();
	console.log("isDataLayerReady:", dataLayerReady);
	console.log("---------- all --------------------")



	// 2023 update - metoda za dohvacanje querystring parametara i prosljedjivanje na radissonhotel site radi trackinga
	// php smartycontroller dohvaca querystring parametre i sprema u cookie, te builda BOOKING url za masku da redirecta na radissonhotel
	// javascript dio uzima cookie (koje je spremio php) i setira za outbound linkove prema radisson hotelu
	  $('a[href^="http"]').each(function(){
        if (this.hostname !== location.hostname && this.hostname.endsWith('radissonhotels.com')) {
			var href = $(this).attr('href');
			var url = new URL(href);

			const paramsToWatch = [
				'facilitatorId',
				'cid',
				'utm_source',
				'utm_medium',
				'utm_campaign',
				'utm_content',
			];

			for (let i = 0; i < paramsToWatch.length; i++) {
				let p = getCookie(paramsToWatch[i]) ?? null;

				// console.log("EACHL", paramsToWatch[i], p);
				// console.log("EACH decodeURI", paramsToWatch[i], decodeURI(p));
				// console.log("EACH decodeHtmlEntity", paramsToWatch[i], decodeURI(p));
				// console.log("EACH unescape", paramsToWatch[i], unescape(p));

				if (p !== null) url.searchParams.append(paramsToWatch[i], unescape(p));
			};

			// radimo unescape jer ovo radi probleme (+ : i sl)
			// &cid=a:pt+b:tba+c:emea+i:brand+e:pph+d:ukirwe+f:en-US+h:gbwestmi

			$(this).attr({
                href: unescape(url.href),
            });
			console.log("STARI url", href);
			console.log("NOVI url", url.href);
        }
    });


});
